import { DecisionRecord, Feature, Product } from '../../models/decision.model';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';
import { UtilsService } from '../../services/utils.service'
import { Router } from '@angular/router';
import { SelectDropDownModule  } from 'ngx-select-dropdown';

@Component({
  selector: 'app-product-decisions',
  templateUrl: './product-decisions.component.html',
 standalone: true,
  imports: [
    CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule,
    SelectDropDownModule    // <-- ADD THIS
  ],
})
export class ProductDecisionsComponent implements OnInit {
  ProductD: any ;
  RO: any;
  multiSelectConfig = {
    displayKey: 'name',
    search: true,
    height: '200px',
    placeholder: 'Select options',
    limitTo: 1000,
    moreText: 'more',
    noResultsFound: 'No results!',
    searchPlaceholder: 'Search',
    clearOnSelection: false,
    inputDirection: 'ltr',
    allowSelectAll: true
  };

  constructor(private playerData: PlayerDataService) {}

  async ngOnInit() {
    // fetch products + features from backend
      const user = JSON.parse(localStorage.getItem('user') || '{}');
    const playerId = user.userId;

    console.log(playerId);

    const cachedprd = await this.playerData.getPageDecisionData('product');

if (typeof cachedprd === 'string') {
  this.ProductD = JSON.parse(cachedprd);
} else if (cachedprd) {
  this.ProductD = cachedprd;
} else {
  this.ProductD = [];
}
    
    console.log("product D in init");
    console.log(this.ProductD[0]);
    console.log(this.ProductD[1]);
    const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    this.RO = roCached;
    console.log(this.RO);
  
   
  }

  getFeatureRows(features: any[]): any[][] {
    const featrows: any  = [];
    if (!features) return featrows;
    for (let i = 0; i < features.length; i += 4) {
      featrows.push(features.slice(i, i + 4));
    }
    return featrows;
  }

  toggleCheckbox(feat: Feature) {
    feat.selectedValue = feat.selectedValue === 'Y' ? 'N' : 'Y';
    this.onInputChange();
  }

  toggleMultiSelect(feat: Feature, val: string) {
    if (!feat.selectedValues) feat.selectedValues = [];
    const idx = feat.selectedValues.indexOf(val);
    if (idx > -1) {
      feat.selectedValues.splice(idx, 1);
    } else {
      feat.selectedValues.push(val);
    }
    this.onInputChange();
  }

  onInputChange() {
    // Update entire product data back to PlayerDataService
    this.playerData.setPageDecisionData('product', this.ProductD);
  }

 // saveProductData() {
   // this.playerData.setPageDecisionData('product', this.ProductD);
 // }

  onCheckboxChange(product: any, feat: any, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    feat.selectedValue = checked ? 'Y' : 'N';
    this.onInputChange();
  }

   onFeatureChange(product: any, feature: any) {
    console.log(`Feature changed for ${product.productName}:`, feature);
    this.onInputChange();
  }
  
 toggleFeatureSelection(product: any, feature: any) {
  feature.selectedValue = feature.selectedValue === 'Y' ? 'N' : 'Y';
   product = [...product];

   this.onFeatureChange(product, feature);
 }
}



